/**
 * Copyright 2024 Design Barn Inc.
 */

export function stripHtmlTags(input: string): string {
  return input.replace(/<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1[^>]*?>(.*?)<\/a>/u, '');
}

export function extractLinkInfo(errorMessage: string): { href: string; text: string } | null {
  const regex = /<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1[^>]*?>(.*?)<\/a>/u;

  const match = regex.exec(errorMessage);

  if (match) {
    return { href: match[2] as string, text: match[3] as string };
  } else {
    return null;
  }
}

export const modifyUiErrors = (errors: string[]): string[] => {
  return errors.map((error) => {
    return error.replace(
      'This backup recovery code has already been used.',
      'This backup recovery code has already been used. Please use another one.',
    );
  });
};
